import PropTypes from 'prop-types';

const BlurMinorIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.2632 12.9474C25.2632 10.8505 26.9558 9.1579 29.0526 9.1579C31.1495 9.1579 32.8421 10.8505 32.8421 12.9474C32.8421 15.0442 31.1495 16.7368 29.0526 16.7368C26.9558 16.7368 25.2632 15.0442 25.2632 12.9474Z"
        fill={fill}
      />
      <path
        d="M26.4211 35.1579C26.4211 33.7684 27.5579 32.6316 28.9474 32.6316C30.3368 32.6316 31.4737 33.7684 31.4737 35.1579C31.4737 36.5474 30.3368 37.6842 28.9474 37.6842C27.5579 37.6842 26.4211 36.5474 26.4211 35.1579Z"
        fill={fill}
      />
      <path
        d="M27.7895 44.7368C27.7895 44.0295 28.3453 43.4737 29.0526 43.4737C29.76 43.4737 30.3158 44.0295 30.3158 44.7368C30.3158 45.4442 29.76 46 29.0526 46C28.3453 46 27.7895 45.4442 27.7895 44.7368Z"
        fill={fill}
      />
      <path
        d="M30.5263 25.1579C30.5263 23.7684 31.6632 22.6316 33.0526 22.6316C34.4421 22.6316 35.5789 23.7684 35.5789 25.1579C35.5789 26.5474 34.4421 27.6842 33.0526 27.6842C31.6632 27.6842 30.5263 26.5474 30.5263 25.1579Z"
        fill={fill}
      />
      <path
        d="M41.4737 27.0526C41.4737 26.3453 42.0295 25.7895 42.7368 25.7895C43.4442 25.7895 44 26.3453 44 27.0526C44 27.76 43.4442 28.3158 42.7368 28.3158C42.0295 28.3158 41.4737 27.76 41.4737 27.0526Z"
        fill={fill}
      />
      <path
        d="M36.6316 8.84211C36.6316 7.45263 37.7684 6.31579 39.1579 6.31579C40.5474 6.31579 41.6842 7.45263 41.6842 8.84211C41.6842 10.2316 40.5474 11.3684 39.1579 11.3684C37.7684 11.3684 36.6316 10.2316 36.6316 8.84211Z"
        fill={fill}
      />
      <path
        d="M36.6316 39.1579C36.6316 37.7684 37.7684 36.6316 39.1579 36.6316C40.5474 36.6316 41.6842 37.7684 41.6842 39.1579C41.6842 40.5474 40.5474 41.6842 39.1579 41.6842C37.7684 41.6842 36.6316 40.5474 36.6316 39.1579Z"
        fill={fill}
      />
      <path
        d="M13.1579 27.0526C13.1579 24.9558 14.8505 23.2632 16.9474 23.2632C19.0442 23.2632 20.7368 24.9558 20.7368 27.0526C20.7368 29.1495 19.0442 30.8421 16.9474 30.8421C14.8505 30.8421 13.1579 29.1495 13.1579 27.0526Z"
        fill={fill}
      />
      <path
        d="M19.4737 14.8421C19.4737 16.2316 18.3368 17.3684 16.9474 17.3684C15.5579 17.3684 14.4211 16.2316 14.4211 14.8421C14.4211 13.4526 15.5579 12.3158 16.9474 12.3158C18.3368 12.3158 19.4737 13.4526 19.4737 14.8421Z"
        fill={fill}
      />
      <path
        d="M20.2105 1.26316C20.2105 1.97053 19.6547 2.52632 18.9474 2.52632C18.24 2.52632 17.6842 1.97053 17.6842 1.26316C17.6842 0.55579 18.24 0 18.9474 0C19.6547 0 20.2105 0.55579 20.2105 1.26316Z"
        fill={fill}
      />
      <path
        d="M17.6842 46.7368C17.6842 46.0295 18.24 45.4737 18.9474 45.4737C19.6547 45.4737 20.2105 46.0295 20.2105 46.7368C20.2105 47.4442 19.6547 48 18.9474 48C18.24 48 17.6842 47.4442 17.6842 46.7368Z"
        fill={fill}
      />
      <path
        d="M4 29.0526C4 28.3453 4.55579 27.7895 5.26316 27.7895C5.97053 27.7895 6.52632 28.3453 6.52632 29.0526C6.52632 29.76 5.97053 30.3158 5.26316 30.3158C4.55579 30.3158 4 29.76 4 29.0526Z"
        fill={fill}
      />
      <path
        d="M30.3158 1.26316C30.3158 1.97053 29.76 2.52632 29.0526 2.52632C28.3453 2.52632 27.7895 1.97053 27.7895 1.26316C27.7895 0.555789 28.3453 0 29.0526 0C29.76 0 30.3158 0.555789 30.3158 1.26316Z"
        fill={fill}
      />
      <path
        d="M48 18.9474C48 19.6547 47.4442 20.2105 46.7368 20.2105C46.0295 20.2105 45.4737 19.6547 45.4737 18.9474C45.4737 18.24 46.0295 17.6842 46.7368 17.6842C47.4442 17.6842 48 18.24 48 18.9474Z"
        fill={fill}
      />
      <path
        d="M6.31579 8.84211C6.31579 7.45263 7.45263 6.31579 8.84211 6.31579C10.2316 6.31579 11.3684 7.45263 11.3684 8.84211C11.3684 10.2316 10.2316 11.3684 8.84211 11.3684C7.45263 11.3684 6.31579 10.2316 6.31579 8.84211Z"
        fill={fill}
      />
      <path
        d="M0 18.9474C0 18.24 0.55579 17.6842 1.26316 17.6842C1.97053 17.6842 2.52632 18.24 2.52632 18.9474C2.52632 19.6547 1.97053 20.2105 1.26316 20.2105C0.55579 20.2105 0 19.6547 0 18.9474Z"
        fill={fill}
      />
      <path
        d="M6.31579 39.1579C6.31579 37.7684 7.45263 36.6316 8.84211 36.6316C10.2316 36.6316 11.3684 37.7684 11.3684 39.1579C11.3684 40.5474 10.2316 41.6842 8.84211 41.6842C7.45263 41.6842 6.31579 40.5474 6.31579 39.1579Z"
        fill={fill}
      />
      <path
        d="M18 37.2632C18 36.5558 18.5558 36 19.2632 36C19.9705 36 20.5263 36.5558 20.5263 37.2632C20.5263 37.9705 19.9705 38.5263 19.2632 38.5263C18.5558 38.5263 18 37.9705 18 37.2632Z"
        fill={fill}
      />
    </svg>
  </div>
);

BlurMinorIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

BlurMinorIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default BlurMinorIcon;
